import {useMemo, useState} from "react";
import {Controller, useForm} from "react-hook-form";
import {
	SelectField,
	InputField
} from "~/components/Forms";
import {
	useCan,
	useCurrentUser,
	useUtilities
} from "~/hooks";
import {
	Button,
	Icon,
	Notification,
	StatusLabel
} from "~/components";

function PersonnelSearchMobile({listGroup, filter, onChange, onSearchChange}) {

	const {utilities} = useUtilities();

	const can = {
		viewAll : useCan('personnelListAll'),
		viewDepartment : useCan('personnelListDepartment'),
		viewGroup : useCan('personnelListGroup'),
	}

	const currentUser   = useCurrentUser();

	const [searchBar, setSearchBar] = useState(false);

	let [listPosition, setListPosition] = useState(utilities.roles);

	if(!can.viewAll && can.viewDepartment && currentUser?.department) {
		listPosition = Object.keys(utilities.roles).filter((key) => {
			return utilities.roles[key].department == currentUser.department;
		}).reduce((obj, key) => {
			obj[key] = utilities.roles[key];
			return obj;
		}, {});
	}

	const positionOptions = useMemo(() => {
		return [{ value: '', label: 'Tất cả' }, ...Object.entries(listPosition).map(([key, value]) => {
			return {
				value: key,
				label: <StatusLabel small type={value.color}>{value.title}</StatusLabel>
			};
		})];
	}, [listPosition]);

	const departmentOptions = [{ value: '', label: <StatusLabel label="Vị trí" type="white" small>Tất cả phòng ban</StatusLabel>}];

	const groupOptions = useMemo(() => {
		return [{ value: '', label: 'Tất cả nhóm' }, ...Object.entries(listGroup).map(([key, item]) => {
			return {value : item.id, label : item.name};
		})];
	}, [listGroup]);

	if(can.viewAll) {
		for (const [key, item] of Object.entries(utilities.departments)) {
			departmentOptions.push({ value : item.key, label : <StatusLabel small type={item.color}>{item.title}</StatusLabel>})
		}
	}

	const listStatus = [
		{value: '', label: 'Tất cả'},
		{value: 'internship', label: 'Thực tập'},
		{value: 'probation', label: 'Thử việc'},
		{value: 'public', label: 'Chính thức'},
		{value: 'trash', label: 'Đã nghỉ'},
	];

	const listMonthBirthday = [
		{value: '', label: 'Tất cả'},
		{value: '1', label: 'Tháng 1'},
		{value: '2', label: 'Tháng 2'},
		{value: '3', label: 'Tháng 3'},
		{value: '4', label: 'Tháng 4'},
		{value: '5', label: 'Tháng 5'},
		{value: '6', label: 'Tháng 6'},
		{value: '7', label: 'Tháng 7'},
		{value: '8', label: 'Tháng 8'},
		{value: '9', label: 'Tháng 9'},
		{value: '10', label: 'Tháng 10'},
		{value: '11', label: 'Tháng 11'},
		{value: '12', label: 'Tháng 12'},
	];

	const {control, handleSubmit, formState: { errors }} = useForm({defaultValues: {}});

	const handleKeywordChange = (e) => {
		if (!onSearchChange) return;
		const newFilter = {
			...filter,
			keyword: e.target.value,
			page: 1,
		};
		onSearchChange(newFilter);
	}

	const handleDepartmentChange = (value) => {
		setListPosition(Object.keys(utilities.roles).filter((key) => {
			return utilities.roles[key].department == currentUser.department;
		}).reduce((obj, key) => {
			obj[key] = utilities.roles[key];
			return obj;
		}, {}));
	};

	const onSubmit = (data) => {
		if (!onChange) return;
		const newFilter = {
			...filter,
			keyword: data.keyword,
			department: data.department,
			role: data.role,
			group: data.group,
			status: data.status,
			birthday: data.birthday,
			page: 1,
		};
		setSearchBar(false);
		onChange(newFilter);
	}

	return (
		<div className="search-bar">
			<div className="container">
				<div className="form">
					<Button type="button" leftIcon={Icon.filter} onClick={() => setSearchBar(true)}>Lọc</Button>
					<InputField name="keyword" placeholder="Tên, email, số điện thoại nhân viên" onChange={handleKeywordChange} />
				</div>
			</div>
			<Notification
				onClose={() => setSearchBar(false)}
				show={searchBar}
				title={'Tìm kiếm'}
				icon={Icon.search}>
				<form className="form form-mobile text-left" autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
					<Controller control={control} name="keyword" render={({ field }) => (
						<InputField label="Tên, email, số điện thoại nhân viên" errors={errors} {...field} />
					)}/>
					{(can.viewAll) &&
						<Controller control={control} name="department" render={({field}) => (
							<SelectField label="Phòng ban" options={departmentOptions} errors={errors} {...field} onChange={(value, event) => {
								handleDepartmentChange(value);
								field.onChange(value, event);
							}} />
						)}/>
					}
					{(can.viewAll || can.viewDepartment) &&
						<Controller control={control} name="role" render={({field}) => (
							<SelectField label="Chọn chức vụ" options={positionOptions} errors={errors} {...field} />
						)}/>
					}
					{(can.viewAll || ((can.viewDepartment || can.viewGroup) && currentUser.department == 'sale')) &&
						<Controller control={control} name="group" render={({field}) => (
							<SelectField label="Chọn nhóm" options={groupOptions} errors={errors} {...field} />
						)}/>
					}
					<Controller control={control} name="status" render={({ field }) => (
						<SelectField label="Trạng thái" options={listStatus} errors={errors} {...field}/>
					)}/>
					<Controller control={control} name="birthday" render={({ field }) => (
						<SelectField label="Sinh nhật" options={listMonthBirthday} errors={errors} {...field}/>
					)}/>
					<div className="d-flex justify-content-between" style={{position:"absolute", bottom:'10px', width:'calc(100% - 20px)'}}>
						<Button background blue style={{width:'100%'}}>Áp dụng</Button>
					</div>
				</form>
			</Notification>
		</div>
	)
}

export default PersonnelSearchMobile;